module.exports = __webpack_public_path__ + "img/ic_share.96487bc9.svg";